/**
 * @Author：zsj
 * @Date：2022/12/19
 */
import React, { useEffect, useState } from 'react'
import { Spin } from 'antd';
import DataControl from '../../store/data-control'

import styles from './index.less'

const Index = () => {
    const [show, setShow] = useState(false)
    useEffect(() => {
        DataControl.setValue('global_loading_fn', setShow)
    }, [])
    if (!show) {
        return null
    }
    return (
        <div className={styles.container}>
            <Spin size='small' />
        </div>
    )
}

export default React.memo(Index)
